module.exports = __webpack_public_path__ + "static/media/bottole-beans.a8cc9fe3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/bottole-beans.jpg
// module id = 601
// module chunks = 0